import React from 'react';

const ActionsBar = ({ onCancel, onDelete, onGenerateEmail, canDelete, canGenerateEmail = true }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-3 md:p-6 flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-3 mt-6">
      {canDelete ? (
        <button 
          type="button"
          onClick={onDelete}
          className="bg-[#EF4444] hover:bg-[#DC2626] text-white px-3 md:px-4 py-2 rounded-lg font-semibold flex items-center justify-center gap-2 transition text-sm md:text-base"
        >
          <i className="bi bi-trash"></i>
          Supprimer
        </button>
      ) : (
        <div></div>
      )}
      <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
        {canGenerateEmail && (
          <button 
            type="button"
            onClick={onGenerateEmail}
            data-testid="actionsbar-rediger-email-ia"
            className="px-3 md:px-5 py-2 bg-[#7C3AED] hover:bg-[#6D28D9] text-white rounded-lg font-semibold shadow-md flex items-center justify-center gap-2 transition text-sm md:text-base"
          >
            <i className="bi bi-envelope-fill"></i>
            <span className="hidden sm:inline">Rédiger email IA</span>
            <span className="sm:hidden">Email IA</span>
          </button>
        )}
        <button 
          type="button"
          onClick={onCancel}
          className="hidden md:block px-3 md:px-6 py-2 md:py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg font-semibold transition text-sm md:text-base"
        >
          Annuler
        </button>
        <button 
          type="submit"
          className="hidden md:block px-4 md:px-8 py-2 md:py-2.5 bg-[#10B981] hover:bg-[#059669] text-white rounded-lg font-bold shadow-md transition text-sm md:text-base"
        >
          <i className="bi bi-check-circle mr-2"></i>
          Enregistrer
        </button>
      </div>
    </div>
  );
};

export default ActionsBar;